import { objectToFormData, makeRequest, SADUKA_TRANSPORT_PREFIX } from 'cityads-v3/utils/apiUtils';
import { yandexReachGoal } from 'cityads-v3/utils/counterUtils';

export const FEEDBACK_REFRESH = 'feedback/FEEDBACK_REFRESH';
export const CLEAR_INPUT_ERROR = 'feedback/CLEAR_INPUT_ERROR';

export const FEEDBACK_SEND = 'feedback/FEEDBACK_SEND';
export const FEEDBACK_SUCCESS = 'feedback/FEEDBACK_SUCCESS';
export const FEEDBACK_FAILURE = 'feedback/FEEDBACK_FAILURE';

export const GET_SUBJECTS = 'feedback/GET_SUBJECTS';
export const GET_SUBJECTS_SUCCESS = 'feedback/GET_SUBJECTS_SUCCESS';
export const GET_SUBJECTS_FAIL = 'feedback/GET_SUBJECTS_FAIL';

export function feedbackRefresh() {
  return {
    type: FEEDBACK_REFRESH
  }
}

export function sendFeedback(data) {
  yandexReachGoal('SEND_CONTACT_FORM');

  const body = objectToFormData(data);

  return makeRequest(`/saduka/feedback`, {
    types: [FEEDBACK_SEND, FEEDBACK_SUCCESS, FEEDBACK_FAILURE],
    options: {
      credentials: 'include',
      method: 'POST',
      body
    },
  });
}

export function getFeedbackSubjects() {
  return makeRequest(`${SADUKA_TRANSPORT_PREFIX}/feedbackSubjects?perpage=1000`, {
    types: [GET_SUBJECTS, GET_SUBJECTS_SUCCESS, GET_SUBJECTS_FAIL],
    options: {
      credentials: 'include'
    },
  });
}

export function clearInputError(fieldName) {
  return {
    type: CLEAR_INPUT_ERROR,
    fieldName
  }
}
